/**
 * セクション一覧ページ専用i18n定数
 */

export const SECTIONS_LIST_I18N = {
  // ステータス
  status: {
    active: $localize`:@@sectionGroupAdmin.sectionsList.status.active:有効`,
    inactive: $localize`:@@sectionGroupAdmin.sectionsList.status.inactive:無効`,
  },

  // ダイアログ
  dialog: {
    confirmTitle: $localize`:@@sectionGroupAdmin.sectionsList.dialog.confirmTitle:ダイアログ確認`,
    confirmMessage: $localize`:@@sectionGroupAdmin.sectionsList.dialog.confirmMessage:ダイアログが表示されます`,
  },
} as const;

export type SectionsListI18n = typeof SECTIONS_LIST_I18N;
